import * as yup from 'yup'
import { IVehicleFeaturesFormValues } from 'features/Vehicles/types'

export const schema = (): yup.SchemaOf<IVehicleFeaturesFormValues> => {
  const validations = {
    features: yup.object().shape({
      brandCoverage: yup.mixed().nullable(),
      amenities: yup.array().of(yup.string().required()),
      make: yup.string().nullable(),
      model: yup.string().nullable(),
      year: yup.number().nullable()
    })
  }

  return yup.object().shape(validations)
}
